module.exports = __webpack_public_path__ + "img/twitter-c.08f0b39.png";